import type { ReactNode } from 'react';
import { useAuthStore } from '@/stores/auth.store';
import { logout as apiLogout } from '@/services/rbac-auth.service';
import { MfaSetupFlow } from '@/components/auth/MfaSetupFlow';
import { ROUTES } from '@/constants';

/** Si el perfil exige enrolar 2º factor (`mfaSetupRequired`), bloquea con el flujo de alta
 *  in-app (`MfaSetupFlow`): elegir correo/app y configurarlo. Al terminar, refresca el perfil
 *  → `mfaSetupRequired` pasa a false → deja pasar. */
export function MfaSetupGate({ children }: { children: ReactNode }): ReactNode {
  const user = useAuthStore((s) => s.user);

  const onLogout = async () => {
    try { await apiLogout(); } catch { /* limpiamos igual */ }
    useAuthStore.getState().clearAuth();
    window.location.href = ROUTES.LOGIN;
  };

  if (user?.mfaSetupRequired) {
    return <MfaSetupFlow onLogout={onLogout} />;
  }
  return children;
}
